import React from 'react'

function Footer() {
  return (
   
    <footer id="footer" className="footer light-background">
      <div className="container">
        <div className="row gy-3">
          <div className="col-lg-3 col-md-6 d-flex">
            <i className="bi bi-geo-alt icon"></i>
            <div className="address">
              <h4>Address</h4>
              <p>Nikunja-2</p>
              <p>Khilkhet, Uttara</p>
              <p></p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 d-flex">
            <i className="bi bi-telephone icon"></i>
            <div>
              <h4>Contact</h4>
              <p>
                <strong>Phone:</strong> <span>+8801742-904023</span><br />
                <strong>Email:</strong> <span>info@powerxone.com, sales@powerxone.com</span><br />
              </p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 d-flex">
            <i className="bi bi-clock icon"></i>
            <div>
              <h4>Operation Hours</h4>
              <p>
                <strong>Sat-Thu:</strong> <span>10AM - 05PM</span><br />
                <strong>Friday</strong>: <span>Closed</span>
              </p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <h4>Follow Us</h4>
            <div className="social-links d-flex">
              <a href="#" className="whatsapp"><i className="bi bi-whatsapp"></i></a>
              <a href="#" className="facebook"><i className="bi bi-facebook"></i></a>
              <a href="#" className="instagram"><i className="bi bi-instagram"></i></a>
              <a href="#" className="linkedin"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>
          <strong className="px-1 sitename">Powerxone.</strong>
          <span>All Rights Reserved</span>
        </p>
        {/* <div className="credits">
         
          Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
        </div> */}
      </div>
    </footer>
   
  )
}

export default Footer
